import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

interface UseCardMarkAsValidatedProps {
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

export const useCardMarkAsValidated = ({ onSuccess, onError }: UseCardMarkAsValidatedProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['clientCardsMarkAsValidated'],
    mutationFn: (magnetic_stripe_data: string) => {
      return privateAxios.post(`/client/cards/mark_as_validated`, {
        card: { magnetic_stripe_data },
      });
    },
    onSuccess,
    onError,
  });
};
